import { useRef, useState } from "react";
import { FileText, Box, X, UploadCloud } from "lucide-react";

export const UploadZone = ({ label, hint, accept, file, onFile, testid, icon = "pdf" }) => {
  const inputRef = useRef(null);
  const [drag, setDrag] = useState(false);
  const Icon = icon === "pdf" ? FileText : Box;

  const handleFiles = (files) => {
    if (files && files[0]) onFile(files[0]);
  };

  return (
    <div
      data-testid={testid}
      onClick={() => !file && inputRef.current?.click()}
      onDragOver={(e) => { e.preventDefault(); setDrag(true); }}
      onDragLeave={() => setDrag(false)}
      onDrop={(e) => { e.preventDefault(); setDrag(false); handleFiles(e.dataTransfer.files); }}
      className={`group relative cursor-pointer rounded-sm border-2 border-dashed p-6 transition-colors duration-200 ${
        drag ? "border-primary bg-primary/5" : file ? "border-primary/60 bg-primary/5" : "border-border hover:border-primary/50 hover:bg-muted/40"
      }`}
    >
      <input
        ref={inputRef}
        type="file"
        accept={accept}
        className="hidden"
        data-testid={`${testid}-input`}
        onChange={(e) => handleFiles(e.target.files)}
      />
      {file ? (
        <div className="flex items-center gap-4">
          <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-sm bg-primary/10 text-primary">
            <Icon className="h-5 w-5" />
          </div>
          <div className="min-w-0 flex-1">
            <div className="truncate font-title text-sm font-semibold">{file.name}</div>
            <div className="font-mono text-xs text-muted-foreground">
              {(file.size / 1024).toFixed(1)} KB
            </div>
          </div>
          <button
            type="button"
            data-testid={`${testid}-clear`}
            onClick={(e) => { e.stopPropagation(); onFile(null); if (inputRef.current) inputRef.current.value = ""; }}
            className="flex h-8 w-8 items-center justify-center rounded-sm text-muted-foreground transition-colors hover:bg-destructive/10 hover:text-destructive"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
      ) : (
        <div className="flex flex-col items-start gap-2">
          <div className="flex h-11 w-11 items-center justify-center rounded-sm bg-muted text-muted-foreground transition-colors group-hover:bg-primary/10 group-hover:text-primary">
            <UploadCloud className="h-5 w-5" />
          </div>
          <div className="font-title text-sm font-semibold">{label}</div>
          <div className="text-xs text-muted-foreground">{hint}</div>
        </div>
      )}
    </div>
  );
};
